module.exports = false;



//////////////////
// WEBPACK FOOTER
// /~/core-js/modules/_library.js
// module id = V3l/
// module chunks = 0